export * from './modal-holder.module';
export * from './modal-holder/modal-holder.component';
export * from './directives/modal-holder.directive';
